'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Components


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _IconPopupModeButton = require('./IconPopupModeButton');

var _IconPopupModeButton2 = _interopRequireDefault(_IconPopupModeButton);

require('./IconPopupModeList.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconPopupModeList = function IconPopupModeList(props) {
    return _react2.default.createElement(
        'ul',
        { className: 'IconPopupModeList' },
        props.modeList.map(function (mode, i) {
            return _react2.default.createElement(
                'li',
                { key: i },
                _react2.default.createElement(_IconPopupModeButton2.default, _extends({}, props, { mode: mode }))
            );
        })
    );
};

IconPopupModeList.propTypes = {
    modeList: _propTypes2.default.array
};

exports.default = IconPopupModeList;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/iconTools/popup/modeMenu/IconPopupModeList.js
// module id = 2238
// module chunks = 0